import styles from "./CategoryBar.module.css";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { BaseURL } from "../../../base/env";
import FilterSort from "./FilterSort/FilterSort";

import { ReactComponent as BackIcon } from "./../../../assets/svg/bottom-arrow.svg";
import sub_no_name from "./../../../assets/images/icons/sub-no-name.png";

import carwash from "../../../assets/svg/car-wash.svg";
import battery from "../../../assets/svg/battery.svg";
import tyre from "../../../assets/svg/tyre.svg";
import oil from "../../../assets/svg/oil.svg";
import autoparts from "../../../assets/svg/car-parts.svg";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import { LangLink } from "../LangLink/LangLink";

export const getSortedParams = (params) => {
  return [
    params.id || null,
    params.sub || null,
    params.c3 || null,
    params.c4 || null,
    params.c5 || null,
    params.c6 || null,
  ].filter((catItem) => catItem !== null);
};

const CategoryBar = (props) => {
  const {
    categories,
    page = "",
    showFilterSort = false,
    activeCategory,
    setActiveCategory,
    withoutUrl,
    showCategory = true,
  } = props;

  const location = useLocation();
  const navigate = useLangNavigate();
  const params = useParams();

  if (!categories) {
    return null;
  }

  const paramsArray = getSortedParams(params);

  const showImageByCategoryId = () => {
    switch (Number(paramsArray[paramsArray.length - 2])) {
      case 2:
        return oil;
      case 4:
        return tyre;
      case 5:
        return carwash;
      case 6:
        return autoparts;
      case 7:
        return battery;
      default:
        return "";
    }
  };
  const SubList =
    activeCategory &&
    categories.find((catItem) => {
      if (withoutUrl) {
        return catItem.id.toString() === (activeCategory || "").toString();
      } else {
        return catItem.id.toString() === paramsArray[paramsArray.length - 2];
      }
    });

  if (!SubList || !SubList.sub_categories) {
    return null;
  }

  return (
    <div className={styles.CategoryBarContainer}>
      {!!categories && (
        <div
          className={`${styles.ParentListContainer} ${
            !showCategory ? styles.Hide : ""
          }`}
        >
          <div className={styles.ParentList}>
            <div className={styles.ParentItems}>
              {categories.map((pitem) => {
                if (withoutUrl) {
                  const isActive =
                    activeCategory.toString() === pitem.id.toString();
                  return (
                    <div
                      key={pitem.id}
                      onClick={() => setActiveCategory(pitem.id.toString())}
                      className={`${styles.ParentItem} ${
                        isActive ? styles.Active : ""
                      }`}
                    >
                      {pitem.name}
                    </div>
                  );
                } else {
                  const subParamsArray = getSortedParams(params);
                  const isActive =
                    subParamsArray[subParamsArray.length - 2].toString() ===
                    pitem.id.toString();
                  subParamsArray[subParamsArray.length - 1] = pitem.id;
                  subParamsArray[subParamsArray.length - 2] = pitem.id;
                  const newUrl = `/${page}${subParamsArray
                    .map((pitem) => `/${pitem}`)
                    .join("")}`;
                  return (
                    <LangLink
                      key={pitem.id}
                      to={newUrl}
                      // to={test && !paramsArray.length ? `${page}/1/${pitem.id}/${pitem.id}` : newUrl}
                      className={`${styles.ParentItem} ${
                        isActive ? styles.Active : ""
                      }`}
                    >
                      {pitem.name}
                    </LangLink>
                  );
                }
              })}
            </div>
          </div>
        </div>
      )}
      {!!categories && (
        <div
          className={`${styles.SubListContainer} ${
            !withoutUrl ? styles.HasReturn : ""
          }`}
        >
          <div
            className={`${styles.SubList} ${
              SubList.sub_categories.length <= 4 &&
              SubList.sub_categories.length > 3
                ? styles.SubListMobile
                : ""
            }`}
          >
            {SubList.sub_categories.map((subItem) => {
              const isActive = withoutUrl
                ? false
                : paramsArray[paramsArray.length - 1].toString() ===
                  subItem.id.toString();
              const subParamsArray = getSortedParams(params);
              if (
                subParamsArray.length <= 2 &&
                subItem.name.toLowerCase() === "all"
              ) {
                return null;
              }
              if (subItem.has_sub_categories && !withoutUrl) {
                subParamsArray[subParamsArray.length - 1] =
                  subItem.id.toString();
                subParamsArray.push(subItem.id.toString());
              } else if (!withoutUrl) {
                subParamsArray[subParamsArray.length - 1] =
                  subItem.id.toString();
              }
              if (withoutUrl) {
                subParamsArray.push(activeCategory.toString());
                subParamsArray.push(
                  subItem.id.toString(),
                  subItem.id.toString()
                );
              }
              const newUrl = `/category${subParamsArray
                .map((pitem) => `/${pitem}`)
                .join("")}`;
              return (
                <LangLink
                  key={subItem.id}
                  to={newUrl}
                  className={styles.SubItem}
                >
                  <div className={`${styles.SubItemImageContainer}`}>
                    <img
                      alt={subItem.name}
                      src={
                        !paramsArray.length
                          ? subItem.image
                          : subItem.name === "All"
                          ? showImageByCategoryId(subItem.id)
                          : subItem.image
                          ? BaseURL + subItem.image
                          : sub_no_name
                      }
                      className={styles.SubItemImage}
                    />
                  </div>
                  <span
                    className={`${styles.SubItemText} ${
                      isActive ? styles.Active : ""
                    }`}
                  >
                    {subItem.name}
                  </span>
                </LangLink>
              );
            })}
          </div>

          <div
            onClick={() => {
              if (paramsArray.length > 3) {
                const subParamsArray = getSortedParams(params);
                subParamsArray.pop();
                const newUrl = `/${page}${subParamsArray
                  .map((pitem) => `/${pitem}`)
                  .join("")}${location.search}`;
                navigate(newUrl);
              } else {
                navigate("/");
              }
            }}
            className={`${styles.BackContainer} ${
              !withoutUrl ? styles.Active : ""
            }`}
          >
            <BackIcon className={styles.BottomArrow} />
          </div>
        </div>
      )}
      {!!showFilterSort && !!activeCategory && (
        <FilterSort category_id={activeCategory} />
      )}
    </div>
  );
};

export default CategoryBar;
